import { Check, History } from "lucide-react";
import { Modal } from "./ui/Overlay";
import { Button } from "./ui/Button";
import { APP_VERSION, RELEASE_HISTORY } from "../lib/releaseHistory";

export default function ReleaseHistoryDialog({ open, onClose }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="版本迭代记录"
      description={`从 V1.1.5 至 ${APP_VERSION} 的功能更新与稳定性改进`}
      width="lg"
      footer={<Button variant="primary" icon={Check} onClick={onClose}>我知道了</Button>}
    >
      <div className="release-history">
        <div className="release-history__summary">
          <span><History size={17} />当前版本</span>
          <strong>{APP_VERSION}</strong>
          <p>这里保留每次线上迭代记录，可通过侧边栏版本号或账号菜单随时重新查看。</p>
        </div>
        <ol className="release-timeline" aria-label="版本迭代时间线">
          {RELEASE_HISTORY.map((release, index) => (
            <li className="release-entry" key={`${release.version}-${release.date}`}>
              <div className="release-entry__rail" aria-hidden="true">
                <span className={index === 0 ? "is-current" : ""} />
              </div>
              <div className="release-entry__meta">
                <strong>{release.version}</strong>
                <time dateTime={release.date}>{release.date}</time>
                {index === 0 ? <em>最新</em> : null}
              </div>
              <article>
                <h3>{release.title}</h3>
                <p>{release.summary}</p>
                <ul>
                  {release.changes.map((change) => <li key={change}>{change}</li>)}
                </ul>
              </article>
            </li>
          ))}
        </ol>
      </div>
    </Modal>
  );
}
